<template>
  <el-row type="flex">
    <el-col :lg="4"
            :md="2"
            class="hidden-sm-and-down">
    </el-col>
    <el-col>
      <router-view></router-view>
    </el-col>
    <el-col :lg="4"
            :md="2"
            class="hidden-sm-and-down">
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'QuotesLayout'
}
</script>
